import { AuthMethod } from "../types";

export interface AuthMethodBadge {
  method: "password" | "face_recognition" | "qr_code";
  label: string;
}

export const getAuthMethodBadge = (
  method?: AuthMethod
): AuthMethodBadge | null => {
  if (method === "password") {
    return { method, label: "Compra com senha" };
  }
  if (method === "face_recognition") {
    return { method, label: "Req. facial" };
  }
  if (method === "qr_code") {
    return { method, label: "Compra com QR code" };
  }
  return null;
};
